import Vue from 'vue'
import store from '@/store'
import VueRouter from 'vue-router'
import AmbienteAluno from '@/components/AmbienteAluno/Index'
import AppDashboard from '@/components/AmbienteAluno/Dashboard'
import CourseList from '@/components/AmbienteAluno/Course/Index'
import QuadroDeNotas from '@/components/AmbienteAluno/Course/QuadroDeNotas'
import Avaliacoes from '@/components/AmbienteAluno/Course/Avaliacoes'
import Test from '@/components/AmbienteAluno/Test/Index'
import Perfil from '@/components/AmbienteAluno/Profile/Index'
import AlterarSenha from '@/components/AmbienteAluno/Profile/AlterarSenha'
import Login from '@/components/Auth/Login'
import ResetPassword from '@/components/Auth/ResetPassword'
import Logout from '@/components/Auth/Logout'
import salaDeAula from '@/components/SalaDeAula/Index'
import Aula from '@/components/SalaDeAula/Aula'
import ForumIndex from '@/components/AmbienteAluno/Forum/Index'
import ForumTopics from '@/components/AmbienteAluno/Forum/Topics'
import Topic from '@/components/AmbienteAluno/Forum/Topic'
import DiscussionForm from '@/components/AmbienteAluno/Forum/DiscussionForm'
import Discussion from '@/components/AmbienteAluno/Forum/Discussion'
import ReplyForm from '@/components/AmbienteAluno/Forum/ReplyForm'
import Verification from '@/components/Auth/FirstAccess/Verification'
import FirstAccessRegister from '@/components/Auth/FirstAccess/Register'
import Register from '@/components/Auth/Register'
import Enroll from '@/components/Enroll/Index'
import CoursePackage from '@/components/Enroll/CoursePackage'
import Cart from '@/components/Cart/Index'
import Plan from '@/components/Plan/Index'
import Annotations from '@/components/AmbienteAluno/Annotations'
import Events from '@/components/AmbienteAluno/Events'
import EventSessions from '@/components/AmbienteAluno/EventSessions'
import EventsEventSessions from '@/components/AmbienteAluno/Events/EventSessions'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'ambienteAluno',
    component: AmbienteAluno,
    meta: { auth: true },
    children: [
      {
        path: '/dashboard',
        name: 'ambienteAluno.dashboard',
        component: AppDashboard,
        meta: { auth: true }
      },
      {
        path: '/cursos',
        name: 'ambienteAluno.course.index',
        component: CourseList,
        meta: { auth: true }
      },
      {
        path: '/annotations',
        name: 'ambienteAluno.annotations',
        component: Annotations,
        meta: { auth: true }
      },
      {
        path: '/events',
        name: 'ambienteAluno.events',
        component: Events,
        meta: { auth: true }
      },
      {
        path: '/events/:eventId/event-sessions',
        name: 'ambienteAluno.events.eventSessions',
        component: EventsEventSessions,
        meta: { auth: true }
      },
      {
        path: '/event-sessions',
        name: 'ambienteAluno.eventSessions',
        component: EventSessions,
        meta: { auth: true }
      },
      {
        path: '/cursos/quadro-notas/:matriculaId',
        name: 'ambienteAluno.course.quadroDeNotas',
        component: QuadroDeNotas,
        props: true,
        meta: { auth: true }
      },
      {
        path: '/turma/:groupId/enrollment/:matriculaId/avaliacoes',
        name: 'ambienteAluno.course.avaliacoes',
        component: Avaliacoes,
        props: true,
        meta: { auth: true }
      },
      {
        path: '/step/:stepId/matricula/:matriculaId/chamada/:chamadaId/avaliacao',
        name: 'ambienteAluno.matricula.avaliacao',
        component: Test,
        props: true,
        meta: { auth: true }
      },
      {
        path: '/perfil',
        name: 'ambienteAluno.perfil',
        component: Perfil,
        meta: { auth: true }
      },
      {
        path: '/alterar-senha',
        name: 'ambienteAluno.alterarSenha',
        component: AlterarSenha,
        meta: { auth: true }
      },
      {
        path: '/forums',
        name: 'ambienteAluno.forum.index',
        component: ForumIndex,
        meta: { auth: true }
      },
      {
        path: '/forums/topics/:forumId',
        name: 'ambienteAluno.forum.topics',
        props: true,
        component: ForumTopics,
        meta: { auth: true }
      },
      {
        path: '/forums/topics/:forumId/topic/:topicId',
        name: 'ambienteAluno.forum.topics.openTopic',
        component: Topic,
        props: true,
        meta: { auth: true },
        children: [
          {
            path: 'new-discussion',
            name: 'ambienteAluno.forum.topics.openTopic.newDiscussion',
            component: DiscussionForm,
            props: true,
            meta: { auth: true }
          },
          {
            path: 'edit-discussion/:discussionId',
            name: 'ambienteAluno.forum.topics.openTopic.editDiscussion',
            component: DiscussionForm,
            props: true,
            meta: { auth: true }
          }
        ]
      },
      {
        path: '/forums/topics/:forumId/topic/:topicId/discussion/:discussionId',
        name: 'ambienteAluno.forum.topics.topic.openDiscussion',
        component: Discussion,
        props: true,
        meta: { auth: true },
        children: [
          {
            path: 'new-reply',
            name: 'ambienteAluno.forum.topics.topic.openDiscussion.newReply',
            component: ReplyForm,
            props: true,
            meta: { auth: true }
          },
          {
            path: 'edit-reply/:replyId',
            name: 'ambienteAluno.forum.topics.topic.openDiscussion.editReply',
            component: ReplyForm,
            props: true,
            meta: { auth: true }
          }
        ]
      }
    ]
  },
  {
    path: '/saladeaula/:matriculaId',
    name: 'salaDeAula',
    component: salaDeAula,
    props: true,
    meta: { auth: true },
    children: [
      {
        path: 'aula/:aulaId',
        name: 'salaDeAula.aula',
        component: Aula,
        props: true,
        meta: { auth: true }
      }
    ]
  },
  {
    path: '/login',
    name: 'auth.login',
    component: Login,
    meta: { auth: false }
  },
  {
    path: '/login/redefinir-senha',
    name: 'auth.resetPassword',
    component: ResetPassword,
    meta: { auth: false }
  },
  {
    path: '/login/redefinir-senha/:token',
    name: 'auth.resetPassword.token',
    component: ResetPassword,
    meta: { auth: false }
  },
  {
    path: '/logout',
    name: 'auth.logout',
    component: Logout,
    meta: { auth: true }
  },
  {
    path: '/register',
    name: 'auth.register',
    component: Register,
    meta: { auth: false }
  },
  {
    path: '/first-access',
    name: 'auth.firstAccess.verification',
    component: Verification,
    meta: { auth: false }
  },
  {
    path: '/first-access-register',
    name: 'auth.firstAccess.register',
    component: FirstAccessRegister,
    beforeEnter: function (to, from, next) {
      if (sessionStorage.getItem('first_access_enrollment') &&
        sessionStorage.getItem('first_access_birth_date')) {
        next()
      } else {
        next('/first-access')
      }
    },
    meta: { auth: false }
  },
  {
    path: '/cart',
    name: 'cart',
    component: Cart,
    meta: { auth: false }
  },
  {
    path: '/plan/:package',
    name: 'plan',
    component: Plan,
    meta: { auth: false }
  },
  {
    path: '/enroll/:unit/:package',
    component: Enroll,
    children: [
      {
        path: '/',
        name: 'enroll.detail',
        component: CoursePackage,
        meta: { auth: false }
      }
    ]
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (!store.getters['App/isAuthenticated'] && to.meta.auth) {
    return router.push({ name: 'auth.login' })
  }
  next()
})

export default router
